import { useCallback } from 'react';

export function useAmountValidation(setBetAmount) {
  const onChange = useCallback(
    (event) => {
      const {
        target: { value },
      } = event;
      if (/^([1]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(value)) {
        return setBetAmount(value);
      }
      if (value === '') {
        return setBetAmount(value);
      }
      return null;
    },
    [setBetAmount]
  );
  return { onChange };
}
